import { BEAT_TYPE } from './EventConst';

export const CHART_EDIT_CONST = {
  HIGHCHARTS_PLOT_BACKGROUND: 'highcharts-plot-background',
  EVENT_MARKER_GROUP: 'huinno-event-marker-group',
  BEAT_MARKER_GROUP: 'huinno-beat-marker-group',
  BEAT_MARKER: 'huinno-beat-marker',
  MOUSE_TRACKER: 'huinno-mouse-tracker',
  VERTICAL_DOTTED_LINE: 'huinno-vertical-dotted-line',
  BEAT_ADD_PLUS_BUTTON: 'huinno-beat-add-plus-button',
  VERTICAL_BEAT_PLOT_LINE: 'huinno-clicked-beat-plot-line',
  SELECTION_MARKER: 'SELECTION_MARKER',
  SELECTION_HIGHLIGHT: 'SELECTION_HIGHLIGHT',
  MAIN_TENSEC_STRIP: 'MAIN_TENSEC_STRIP',
  EXTRA_TENSEC_STRIP: 'EXTRA_TENSEC_STRIP',
  REPORT_REPRESENTATIVE_STRIP: 'REPORT_REPRESENTATIVE_STRIP',
  TEN_SEC_STRIP_MOVE_DIR: {
    PREV: 'PREV',
    NEXT: 'NEXT',
  },
};

export const SELECTION_MARKER_TYPE = {
  ONSET: 'ONSET',
  TERMINATION: 'TERMINATION',
  RESET: 'RESET',
};

export const STRIP_TYPE = {
  SINGLE_LINE: 'SINGLE_LINE',
  MULTI_LINE: {
    ONSET: 'ONSET',
    MIDDLE: 'MIDDLE',
    TERMINATION: 'TERMINATION',
  },
};

export const TEN_SEC_STRIP = {
  TYPE: {
    MAIN: 'main',
    EXTRA: 'extra',
    RESET: 'reset',
  },
  POSITION: {
    PREV: 'PREV',
    NONE: 'NONE',
    NEXT: 'NEXT',
  },
  MOVE_TYPE: {
    PREV: 'PREV',
    NEXT: 'NEXT',
  },
};

export const HIGHCHART_UNIT = {
  LOCATION: 'LOCATION',
  PIXEL: 'PIXEL',
};

export const EDIT_CHART = {
  VALIDATION: {
    EXTEND_SELECTION_STRIP: 'EXTEND_SELECTION_STRIP',
    PREVENT_RENDER_TENSEC_STRIP: 'PREVENT_RENDER_TENSEC_STRIP',
    REMOVE_CONTEXTMENU: 'REMOVE_CONTEXTMENU',
    SHOW_CONTEXTMENU: 'SHOW_CONTEXTMENU',
    REMOVE_SELECTION_HIGHLIGHT_ALL: 'REMOVE_SELECTION_HIGHLIGHT_ALL',
    RENDER_TENSEC_STRIP: 'RENDER_TENSEC_STRIP',
    RENDER_SELECTION_STRIP: 'RENDER_SELECTION_STRIP',
    PREVENT_SECTION_STRIP: 'PREVENT_SECTION_STRIP',
    PREVENT_SHIFT_CLICK: 'PREVENT_SHIFT_CLICK',
  },
};

export const REPORT_REPRESENTATIVE_STRIP = {
  TYPE: {
    WHOLELINE: 'WHOLELINE',
    ONELINE: 'ONELINE',
    MULTILINE: {
      BEGIN: 'BEGIN',
      MID: 'MID',
      END: 'END',
    },
  },
};

export const ECG_CHART_UNIT = {
  MS_UNIT_PER_CHART_POINT: 4,
  FOUR_SEC: 4 * 1000,
  FIVE_SEC: 5 * 1000,
  TEN_SEC: 10 * 1000,
  FOUR_SEC_WAVEFORM_IDX: (2500 / 10) * 4,
  FIVE_SEC_WAVEFORM_IDX: (2500 / 10) * 5, // 10초에 2500개 waveform index
  TEN_SEC_WAVEFORM_IDX: 2500,
  HALF_TEN_SEC_WAVEFORM_IDX: 2500 / 2,
  THIRTY_SEC_WAVEFORM_IDX: 7500,
};

export const TEN_SEC_STRIP_EDIT = {
  BEAT_TYPE: ['N', 'S', 'V', 'Q'],
  BEAT_COLOR_TYPE: ['COOL_GRAY_90', 'SVE_70', 'VE_70', 'COOL_GRAY_70'],
};

export const BEAT_BUTTON_COLOR_MAP = {
  [BEAT_TYPE.NORMAL]: 'COOL_GRAY_90',
  [BEAT_TYPE.APC]: 'SVE_70',
  [BEAT_TYPE.VPC]: 'VE_70',
  [BEAT_TYPE.NOISE]: 'COOL_GRAY_70',
};
export const SELECTED_BEAT_BUTTON_STROKE_MAP = {
  [BEAT_TYPE.NORMAL]: 'BLUE_70',
  [BEAT_TYPE.APC]: 'SVE_70',
  [BEAT_TYPE.VPC]: 'VE_70',
  [BEAT_TYPE.NOISE]: 'COOL_GRAY_90',
};
export const SELECTED_BEAT_BUTTON_FILL_MAP = {
  [BEAT_TYPE.NORMAL]: 'BLUE_40',
  [BEAT_TYPE.APC]: 'SVE_40',
  [BEAT_TYPE.VPC]: 'VE_40',
  [BEAT_TYPE.NOISE]: 'COOL_GRAY_50',
};

export const PLOT_LINE_COLOR_MAP = {
  [BEAT_TYPE.NORMAL]: 'BLUE_50',
  [BEAT_TYPE.APC]: 'SVE_50',
  [BEAT_TYPE.VPC]: 'VE_50',
  [BEAT_TYPE.NOISE]: 'COOL_GRAY_50',
};

export const TEN_SEC_STRIP_DETAIL = {
  EDIT_MODE: {
    INIT: 'INIT',
    ADD_BEAT: 'ADD_BEAT',
    CHANGE_BEAT: 'CHANGE_BEAT', // show: beat option button
    CALIPER: 'CALIPER',
    TICK_MARKS: 'TICK_MARKS',
  },
  TAB: {
    ARRHYTHMIA_CONTEXTMENU: 'ARRHYTHMIA_CONTEXTMENU',
    EVENT_REVIEW: 'EVENT_REVIEW',
    HR_REVIEW: 'HR_REVIEW',
    BEAT_REVIEW: 'BEAT_REVIEW',
    SHAPE_REVIEW: 'SHAPE_REVIEW',
  },
};

export const TEN_SEC_SCRIPT_DETAIL = {
  HR: 'hr',
  BEAT_TYPE: 'beatType',
  WAVEFORM_INDEX: 'waveformIndex',
};

export const AMPLITUDE_OPTION = {
  FIVE_MV: { LABEL: 5, RATE: 0.5 },
  TEN_MV: { LABEL: 10, RATE: 1 },
  TWENTY_MV: { LABEL: 20, RATE: 2 },
  THIRTY_MV: { LABEL: 30, RATE: 3 },
  FORTY_MV: { LABEL: 40, RATE: 4 },
};
// position 시작: 1, array 시작: 0인이유로 offset이 필요
export const OFFSET_POSITION_ARRAY = 1;

/**
 * @typedef {Object} positionMoveType
 * @property {string} INIT
 * @property {string} JUMP
 * @property {string} PREV
 * @property {string} NEXT
 */

/**
 * @type {positionMoveType}
 */
export const POSITION_MOVE_TYPE = {
  INIT: 'INIT', // side panel event click
  JUMP: 'JUMP', // position move by typing number in input box
  PREV: 'PREV', // position move by left arrow key
  NEXT: 'NEXT', // position move by right arrow key
};

/**
 * @typedef {Object} rawAndEventCalledCase
 * @property {string} KEY_EVENT
 * @property {string} CLICK_EVENT
 * @property {string} DATA_POLLING
 * @property {string} POSITION_JUMP
 */

/**
 * @type {rawAndEventCalledCase}
 */
export const rawAndEventCalledCase = {
  KEY_EVENT: 'KEY_EVENT',
  CLICK_EVENT: 'CLICK_EVENT',
  DATA_POLLING: 'DATA_POLLING',
  POSITION_JUMP: 'POSITION_JUMP',
};

export const BEAT_REVIEW_FETCHING_OPTION = {
  BASIS_FETCHING_COUNT: 30,
  BACKWARD_FETCHING_COUNT: 10,
  BASIS_NUMBER_OF_START_POOLING: 20,
  SAMPLE_SIZE: 2500,
  EXTRA_FETCHING_SAMPLE_SIZE: 500,
};

export const BEAT_REVIEW_EVENT_DETAIL_FETCHING_TYPE = {
  INIT: '', // 아래 NEW, PREPARING이 아닌 케이스
  NEW: 'NEW', // position jump시 fetching 받을 때 position이 없는 구간 이동시
  PREPARING: 'PREPARING', // position move시 미리 data를 fetching 받을 때
};
